"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorsDarkTheme = exports.colorsLightTheme = void 0;
var colorsLightTheme = {
  onBackground: "hsla(220, 7%, 8%, 1)",
  onSurface1: "hsla(220, 7%, 8%, 1)",
  onSurface2: "hsla(220, 7%, 8%, 1)",
  onPrimary: "hsla(0, 0%, 95%, 1)",
  onSecondary: "hsla(0, 0%, 95%, 1)",
  background: "hsla(0, 0%, 100%, 1)",
  surface1: "hsla(0, 0%, 95%, 1)",
  surface2: "hsla(0, 0%, 85%, 1)",
  primary: "hsla(230, 25%, 58%, 1)",
  secondary: "hsla(230, 28%, 45%, 1)"
};
exports.colorsLightTheme = colorsLightTheme;
var colorsDarkTheme = {
  onBackground: "hsla(0, 0%, 100%, 1)",
  onSurface1: "hsla(0, 0%, 100%, 1)",
  onSurface2: "hsla(0, 0%, 100%, 1)",
  onPrimary: "hsla(0, 0%, 0%, 1)",
  onSecondary: "hsla(0, 0%, 0%, 1)",
  background: "hsla(0, 0%, 0%, 1)",
  surface1: "hsla(0, 0%, 20%, 1)",
  surface2: "hsla(0, 0%, 30%, 1)",
  primary: "hsla(230, 25%, 68%, 1)",
  secondary: "hsla(230, 25%, 78%, 1)"
};
exports.colorsDarkTheme = colorsDarkTheme;